module.exports = __webpack_public_path__ + "files/fc11df6ac6f5475579efc0c88093b183.png";